<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :value="value"
    :multiple="multiple"
    :taggable="taggable"
    @search="onSearch"
    :filterable="false"
    @input="(selectedTags) => $emit('input', selectedTags)"
  >
    <template #no-options="{ search, searching }">
      <template v-if="searching">
        No results found for
        <em>{{ search }}</em>
      </template>
      <em
        style="opacity: 0.7"
        v-else
      >Type to add tags</em>
    </template>
  </v-select>
</template>
<script>
import { debounce as _debounce } from 'lodash';

export default {
  name: 'WorkOrderTagsSelect',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: 'work-order-tags',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: String,
    multiple: {
      type: Boolean,
      default: true,
    },
    taggable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: [],
    };
  },
  methods: {
    onSearch(text, loading) {
      if (text.length) {
        loading(true);
        this.searchTags(text, loading, this);
      }
    },
    searchTags: _debounce((text, loading, vm) => {
      vm.$workOrdersAPI.searchTags({ text }).then((tagOptions) => {
        vm.options = vm.mergeTagOptions(tagOptions);
        loading(false);
      }).catch(() => {
        loading(false);
      });
    }, 500),
    mergeTagOptions(tagOptions = []) {
      return [...new Set([...(this.value || []), ...tagOptions])];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(selectedTags) {
        this.options = this.mergeTagOptions(selectedTags);
      },
    },
  },
};
</script>
